import * as React from "react"

import { cn } from "../../utils"

function Input({ className, type, ...props }: React.ComponentProps<"input">) {
  return (
    <input
      type={type}
      data-slot="input"
      className={cn(
        "!h-9 w-full min-w-0 !rounded-full !border !border-gray-200 !bg-gray-100 !pl-3 !pr-3 !py-2 !text-sm !text-gray-700 !shadow-none transition-[color,box-shadow,border-color] !outline-none selection:bg-primary selection:text-primary-foreground file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground !placeholder:text-input-placeholder disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 !mb-0",
        "focus-visible:!border-blue-500 focus-visible:!ring-0",
        "aria-invalid:!border-rose-600 aria-invalid:!ring-0",
        className
      )}
      {...props}
    />
  )
}

export { Input }
